import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppMaterial } from 'application/components/api/EppMaterial';

export const eppMaterialAdapter = createEntityAdapter<IEppMaterial, number>({
  selectId: (project) => project.eppMaterialID,
});
